/**
 * Host-platform detection helpers — extracted into a shared module so
 * both `post-message.ts` (method dispatch) and `web-transport.ts`
 * (handshake / ready) can use them without a circular import.
 *
 * Each helper returns a boolean derived purely from globals — no side
 * effects, no state. Safe to call any number of times. Returns sane
 * defaults under SSR / Node where `window` is undefined.
 */

export const hasAndroidPostMessage = (): boolean =>
    !!(
        typeof (window as any) !== 'undefined' &&
        (window as any).ortaWebView &&
        (window as any).ortaWebView.postMessage
    );

export const hasWebKitPostMessage = (): boolean =>
    !!(
        typeof (window as any) !== 'undefined' &&
        (window as any).webkit &&
        (window as any).webkit.messageHandlers &&
        (window as any).webkit.messageHandlers.ortaWebView &&
        (window as any).webkit.messageHandlers.ortaWebView.postMessage
    );

/** True when the document is running inside an iframe (any nesting
 *  level). Catches the cross-origin SecurityError that `window.top`
 *  throws when the top frame is on a different origin — that's still
 *  "in iframe" for our purposes. */
export const isInIframe = (): boolean => {
    if (typeof (window as any) === 'undefined') return false;
    try {
        return (window as any).self !== (window as any).top;
    } catch {
        return true;
    }
};
